import { FunctionComponent } from 'react';
import { Button, Image } from '@chakra-ui/react';
import { images } from '../support/imageSupport';


export interface ButtonParams {
    title: string | null
    visible: boolean
    image: string | null
    disabled?: boolean
}

interface ButtonProps {
    title: string | null
    variant?: string
    size?: string
    w?: string
    p?: number
    image: string | null
    visible: boolean
    action: () => void
    disabled?: boolean

}


const BtButton: FunctionComponent<ButtonProps> = ({ title, image, action, variant, size, w, p, visible, disabled }) => {

    return (<>
        {visible && <Button variant={variant} size={size} w={w} p={p} onClick={() => action()} disabled={disabled === undefined ? false : disabled}>
            {title !== null && title}
            {image !== null && <Image px='2' src={images(image)} />}

        </Button>}
        {!visible && <Button variant={variant} size={size} w={w} p={p} onClick={() => { }} disabled>

        </Button>}
    </>
    )

}

export default BtButton;


